var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNcFileLinked = function SvgNcFileLinked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#FC0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m7.48 6.374 1.114 1.592 1.08.19-.205 1.162c-.106.6.44.919.983.639l2.75-1.393a.57.57 0 0 0 .163-.92l-2.107-2.259c-.4-.432-1.033-.352-1.142.264l-.204 1.154zM3.026 7.175c-.383.068-.644.417-.578.79a.695.695 0 0 0 .809.564l3.63-.639-1.592-1.095z"
  })));
};
export default SvgNcFileLinked;